import {createFeatureSelector, createSelector} from '@ngrx/store'
import {Features} from '../features'
import {SamoobslugaStanInterface} from './types/samoobsluga-stan.interface'

export const samoobslugaSelector = createFeatureSelector<SamoobslugaStanInterface>(Features.SAMOOBSLUGA)

export const numerSzkodySelector = createSelector(
  samoobslugaSelector, (selfServiceState: SamoobslugaStanInterface) => selfServiceState.nrSzkody
)

export const correlationIdSelector = createSelector(
  samoobslugaSelector, (selfServiceState: SamoobslugaStanInterface) => selfServiceState.correlationId
)

export const tokenSelector = createSelector(
  samoobslugaSelector, (selfServiceState: SamoobslugaStanInterface) => selfServiceState.token
)

export const stanSelector = createSelector(
  samoobslugaSelector, (selfServiceState: SamoobslugaStanInterface) => selfServiceState.stanSamoobslugi
)

export const tenantSelector = createSelector(
  samoobslugaSelector, (selfServiceState: SamoobslugaStanInterface) => selfServiceState.tenant
)

export const linkAnkietaSelector = createSelector(
  samoobslugaSelector, (selfServiceState: SamoobslugaStanInterface) => selfServiceState.linkAnkieta
)
